<template lang="">
  <div class="container-fluid mt-8">
    <div class="d-flex flex-row">
      <div class="flex-row-auto offcanvas-mobile w-250px w-xxl-300px">
        <div class="card card-custom card-stretch rounded-xl">
          <div class="aside-menu card-body py-0 px-5 rounded-xl">
            <ul v-if="$store.state.modules.length" class="menu-nav">
              <template v-for="(nav, i) in $store.state.modules">
                <span v-if="nav.group && ( i>0 ? $store.state.modules[i-1].group ? $store.state.modules[i-1].group !== nav.group : true : true )" :key="i + 'separator'" class="d-block font-weight-bold font-size-lg mb-3" :class="{ 'mt-4' : i>0 }">{{ nav.group }}</span>
                <li v-if="nav.routes.length > 1" :key="i" :ref="'sidemenu-' + i" class="menu-item menu-item-submenu" :class="{ 'menu-item-here menu-item-open' : (nav.routes.map(x=> x.name).indexOf($route.name) !== -1) }" aria-haspopup="true" data-menu-toggle="hover">
                  <a
                    href="javascript:;"
                    @click="
                      toggleClass('sidemenu-' + i, ['menu-item-here', 'menu-item-open'])
                      toggleClass('sidemenu-sub-' + i, ['d-none', 'overflow-hidden'])
                    "
                    class="menu-link menu-toggle pr-3 pl-3"
                  >
                    <span class=" menu-icon">
                      <i :class="nav.icon"></i>
                    </span>
                    <span class="menu-text text-dark-65">
                      {{
                        nav.name
                          .split('-')
                          .map(
                            (kebab) =>
                              kebab
                                .toLowerCase()
                                .charAt(0)
                                .toUpperCase() + kebab.slice(1)
                          )
                          .join(' ')
                      }}
                    </span>
                    <i class="menu-arrow"></i>
                  </a>
                  <div class="menu-submenu pt-2" :class="{ 'd-none overflow-hidden' : !(nav.routes.map(x=> x.name).indexOf($route.name) !== -1) }" :ref="'sidemenu-sub-' + i">
                    <i class="menu-arrow"></i>
                    <ul class="menu-subnav">
                      <li v-for="(sub, j) in nav.routes" :key="j" class="menu-item " aria-haspopup="true">
                        <router-link :to="createLink(sub)" class="menu-link pr-5 pl-3" :class="{'bg-light-secondary': $route.name === sub.name }">
                          <i :class="[$route.name === sub.name ? 'text-secondary font-weight-bolder' : 'text-dark']" class="menu-bullet mr-2 ri-arrow-right-s-fill"></i>
                          <span :class="{'text-secondary font-weight-bolder': $route.name === sub.name }" class="menu-text">{{ sub.label || sub.meta.title }}</span>
                        </router-link>
                      </li>
                      <!-- <li class="menu-item menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover">
                        <a href="javascript:;" class="menu-link menu-toggle">
                          <i class="menu-bullet menu-bullet-dot"><span></span></i>
                          <span class="menu-text">Login</span>
                          <i class="menu-arrow"></i>
                        </a>
                        <div class="menu-submenu " style="display: none; overflow: hidden;" kt-hidden-height="200">
                          <i class="menu-arrow"></i>
                          <ul class="menu-subnav">
                            <li class="menu-item " aria-haspopup="true">
                              <a href="/metronic/demo5/custom/pages/login/login-1.html" class="menu-link ">
                                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                <span class="menu-text">Login 1</span>
                              </a>
                            </li>
                            <li class="menu-item " aria-haspopup="true">
                              <a href="/metronic/demo5/custom/pages/login/login-2.html" class="menu-link ">
                                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                <span class="menu-text">Login 2</span>
                              </a>
                            </li>
                            <li class="menu-item  menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover">
                              <a href="javascript:;" class="menu-link menu-toggle">
                                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                <span class="menu-text">Login 3</span>
                                <span class="menu-label"><span class="label label-inline label-info">Wizard</span></span>
                                <i class="menu-arrow"></i>
                              </a>
                              <div class="menu-submenu ">
                                <i class="menu-arrow"></i>
                                <ul class="menu-subnav">
                                  <li class="menu-item " aria-haspopup="true">
                                    <a href="/metronic/demo5/custom/pages/login/login-3/signup.html" class="menu-link ">
                                      <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                      <span class="menu-text">Sign Up</span>
                                    </a>
                                  </li>
                                  <li class="menu-item " aria-haspopup="true">
                                    <a href="/metronic/demo5/custom/pages/login/login-3/signin.html" class="menu-link ">
                                      <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                      <span class="menu-text">Sign In</span>
                                    </a>
                                  </li>
                                  <li class="menu-item " aria-haspopup="true">
                                    <a href="/metronic/demo5/custom/pages/login/login-3/forgot.html" class="menu-link ">
                                      <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                      <span class="menu-text">Forgot Password</span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="menu-item  menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover">
                              <a href="javascript:;" class="menu-link menu-toggle">
                                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                <span class="menu-text">Login 4</span>
                                <span class="menu-label"><span class="label label-inline label-info">Wizard</span></span>
                                <i class="menu-arrow"></i>
                              </a>
                              <div class="menu-submenu ">
                                <i class="menu-arrow"></i>
                                <ul class="menu-subnav">
                                  <li class="menu-item " aria-haspopup="true">
                                    <a href="/metronic/demo5/custom/pages/login/login-4/signup.html" class="menu-link ">
                                      <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                      <span class="menu-text">Sign Up</span>
                                    </a>
                                  </li>
                                  <li class="menu-item " aria-haspopup="true">
                                    <a href="/metronic/demo5/custom/pages/login/login-4/signin.html" class="menu-link ">
                                      <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                      <span class="menu-text">Sign In</span>
                                    </a>
                                  </li>
                                  <li class="menu-item " aria-haspopup="true">
                                    <a href="/metronic/demo5/custom/pages/login/login-4/forgot.html" class="menu-link ">
                                      <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                      <span class="menu-text">Forgot Password</span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="menu-item  menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover">
                              <a href="javascript:;" class="menu-link menu-toggle">
                                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                <span class="menu-text">Classic</span>
                                <i class="menu-arrow"></i>
                              </a>
                              <div class="menu-submenu ">
                                <i class="menu-arrow"></i>
                                <ul class="menu-subnav">
                                  <li class="menu-item " aria-haspopup="true">
                                    <a href="/metronic/demo5/custom/pages/login/classic/login-1.html" class="menu-link ">
                                      <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                      <span class="menu-text">Login 1</span>
                                    </a>
                                  </li>
                                  <li class="menu-item " aria-haspopup="true">
                                    <a href="/metronic/demo5/custom/pages/login/classic/login-2.html" class="menu-link ">
                                      <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                      <span class="menu-text">Login 2</span>
                                    </a>
                                  </li>
                                  <li class="menu-item " aria-haspopup="true">
                                    <a href="/metronic/demo5/custom/pages/login/classic/login-3.html" class="menu-link ">
                                      <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                      <span class="menu-text">Login 3</span>
                                    </a>
                                  </li>
                                  <li class="menu-item " aria-haspopup="true">
                                    <a href="/metronic/demo5/custom/pages/login/classic/login-4.html" class="menu-link ">
                                      <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                      <span class="menu-text">Login 4</span>
                                    </a>
                                  </li>
                                  <li class="menu-item " aria-haspopup="true">
                                    <a href="/metronic/demo5/custom/pages/login/classic/login-5.html" class="menu-link ">
                                      <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                      <span class="menu-text">Login 5</span>
                                    </a>
                                  </li>
                                  <li class="menu-item " aria-haspopup="true">
                                    <a href="/metronic/demo5/custom/pages/login/classic/login-6.html" class="menu-link ">
                                      <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                      <span class="menu-text">Login 6</span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </li> -->
                    </ul>
                  </div>
                </li>
                <li v-else :key="i" :ref="'sidemenu-' + i" class="menu-item" :class="{ 'menu-item-here' : $route.name == nav.routes[0].name }" aria-haspopup="true">
                  <router-link :to="createLink(nav.routes[0])" class="menu-link pr-5 pl-3">
                    <span class="menu-icon">
                      <i :class="nav.routes[0].icon"></i>
                    </span>
                    <span class="menu-text text-dark-65">
                      {{ nav.routes[0].label || nav.routes[0].meta.title}}
                    </span>
                  </router-link>
                </li>
              </template>
            </ul>
          </div>
          <!-- <pre>{{ $store.state.modules }}</pre> -->
        </div>
      </div>
      <div class="flex-row-fluid">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'admin-inner-dashboard-layout',
  methods: {
    toggleClass (ref, className) {
      if (this.$refs[ref]) { className.map((x) => this.$refs[ref][0].classList.toggle(x)) }
    },
    createLink (s) {
      if (this.$route.name !== s.name || this.$route.query.view !== 'list') {
        return { name: s.name, query: { view: 'list' } }
      } else return { query: { view: 'list' } }
    }
  }
}
</script>
<style>
.menu-item-here .menu-link.menu-toggle {
    background-color: var(--bg-secondary);
}
.menu-item-here>.menu-link{
    background-color: var(--secondary-light-theme);
}

.menu-link .menu-icon {
  flex: 0 0 25px !important;
}
.menu-link .menu-text,
.menu-link i.menu-arrow{
    font-weight: 500 !important;
}
.menu-link .menu-text{
    font-size: 14px !important;
}
.menu-item-here .menu-link.menu-toggle .menu-icon i,
.menu-item-here .menu-link.menu-toggle .menu-text,
.menu-item-here .menu-link.menu-toggle i.menu-arrow,
.menu-item-here>.menu-link .menu-icon i,
.menu-item-here>.menu-link .menu-text,
.menu-item-here>.menu-link i.menu-arrow{
    font-weight: 600 !important;
}
.menu-submenu {
    animation: growDown 200ms ease-in-out forwards;
    transform-origin: top center;
}
@keyframes growDown {
    0% {
        transform: scaleY(0)
    }
    80% {
        transform: scaleY(1.1)
    }
    100% {
        transform: scaleY(1)
    }
}

</style>



// WEBPACK FOOTER //
// src/layouts/tas-inner-admin.vue